<template>
    <img
            :src="imageSrc"
            class="file-resource-thumbnail"
            :alt="fileAppResource.fileTitle"
            :style="thumbnailStyles"
            v-if="imageSrc"
    >
</template>

<script>
    import './FileResourceThumbnail.scss';
    import FileAppResource from '@milestoneslabs/milestones-core-js/src/AppResources/FileAppResource';

    export default {
        name: 'FileResourceThumbnail',
        layout: 'default',

        components: {},

        props: {
            fileAppResource: {
                type: FileAppResource,
                required: true,
            },
            thumbHeight: {
                type: String,
                required: false,
                default: '1.5rem',
            },
            thumbWidth: {
                type: String,
                required: false,
                default: '1.5rem',
            },
        },


        data() {
            return {
                fileIcons: {
                    'pdf': 'pdf.svg',
                    'ppt': 'powerpoint.svg',
                    'pptx': 'powerpoint.svg',
                    'doc': 'word.svg',
                    'docx': 'word.svg',
                    'xls': 'excel.svg',
                    'xlsx': 'excel.svg',
                    'zip': 'zipped.svg',
                    'zipx': 'zipped.svg',
                    'rar': 'zipped.svg',
                    '7z': 'zipped.svg',
                },
                imageExtensions: [
                    'png',
                    'jpg',
                    'jpeg',
                    'gif',
                    'webp',
                ],
                imageSrc: null,
            };
        },

        computed: {
            thumbnailStyles() {
                return {
                    height: this.thumbHeight,
                    width: this.thumbWidth,
                };
            },
        },

        methods: {
            thumbnail(fileAppResource) {
                const fileExtension = fileAppResource instanceof FileAppResource ?
                    fileAppResource.fileExtension :
                    fileAppResource.fileTitle.split('.').pop().trim();
                const iconExtension = this.fileIcons[fileExtension];
                if (this.imageExtensions.includes(fileExtension)) {
                    this.imageSrc = fileAppResource.publicUrl;
                } else if (iconExtension) {
                    this.handleExtension(iconExtension);
                }
            },

            handleExtension(iconExtension) {
                const fileIcon = `${require('./../../../static/file-icons/' + iconExtension)}`;
                if (fileIcon) {
                    this.imageSrc = fileIcon;
                }
            },
        },

        watch: {
            fileAppResource: {
                immediate: true,
                handler() {
                    this.thumbnail(this.fileAppResource);
                },
            },
        },
    };
</script>
